<template>
	<div>

		<PageHeader :title="TR.contacts" icon="far fa-envelope" />

		<div class="contacts-page container py-3 py-sm-5" >
			<div class="row">
				<div class="col-md-6 maps p-0 pe-sm-5" v-html='map_frame'></div>
				<!-- <iframe src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d11880.492291371422!2d12.4922309!3d41.8902102!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x28f1c82e908503c4!2sColosseo!5e0!3m2!1sit!2sit!4v1524815927977" frameborder="0" style="border:0" allowfullscreen></iframe> -->

				<div class="col-md-6 p-2">
					<h4 class="mt-3 mt-sm-0 fw-bold">{{TR.write_us}}</h4>
					<form action="">
						<div class="row">
							<div class="col-lg-6 mt-3">
								<input type="text" class="form-control" :placeholder="TR.firstname" @invalid="InvalidMsg($event, TR.msg_params_error)" required>
							</div>
							<div class="col-lg-6 mt-3">
								<input type="text" class="form-control" :placeholder="TR.lastname" @invalid="InvalidMsg($event, TR.msg_params_error)" required>
							</div>
							<div class="col-lg-6 mt-3">
								<input type="email" class="form-control" :placeholder="TR.email" @invalid="InvalidMsg($event, TR.msg_params_error)" required>
							</div>
							<div class="col-lg-6 mt-3">
								<input type="text" class="form-control" :placeholder="TR.phone">
							</div>
							<div class="col-12 mt-3">
								<textarea class="form-control" id="exampleFormControlTextarea1" :placeholder="TR.text" rows="3" @invalid="InvalidMsg($event, TR.msg_params_error)" required></textarea>
							</div>
							<div class="col-12 mt-3">
								<div class="form-group">
									<div class="form-check">
										<input class="form-check-input cursor-pointer" type="checkbox" value="" id="rememberCheck" @invalid="InvalidMsg($event, TR.noselect)" required />
										<label class="form-check-label cursor-pointer" for="rememberCheck">
											{{TR.agree_terms}}
										</label>
									</div>
								</div>
							</div>
							<div class="col-12 mt-3 text-center">
								<button class="btn btn-dark bg-site border-0" type="submit"><i class="fas fa-paper-plane me-2"></i>{{ TR.send }}</button>
							</div>
						</div>
					</form>
					<div class="mt-5">
						<hr>
						<i class="fas fa-phone mt-3 me-2"></i> <a :href="'tel:' + G.systemData?.phone?.value">{{ G.systemData?.phone?.value }}</a><br>
						<i class="fas fa-envelope mt-3 me-2"></i> <a :href="'mailto:' + G.systemData?.email?.value">{{ G.systemData?.email?.value }}</a><br>
						<i class="fas fa-map-marked mt-3 me-2"></i>{{ G.systemData?.address?.value }}<br>
						<!-- <i class="fas fa-globe mt-3 me-2"></i> Piazza del Colosseo, 1, 00184 Roma<br> -->
						<!-- <div class="my-4">
							<a href=""><i class="fab fa-facebook fa-3x pr-4"></i></a>
							<a href=""><i class="fab fa-linkedin fa-3x"></i></a>
						</div> -->
					</div>
				</div>
			</div>
		</div>

	</div>
</template>

<script>
import { ref, watchEffect } from 'vue';
import { useStore } from '@/store';

import PageHeader from '@/components/header/PageHeader';
import { G } from '@/_common';

export default {
	name: 'ContactsP',
	title: 'contacts',
	components: {
		PageHeader
	},
	props: {
		data: {
			type: Object
		}
	},
	setup() {
		const store = useStore();

		const TR = ref([]);
		const map_frame = ref("");

		watchEffect(() => {
			TR.value = store.getTranslation();
			map_frame.value = G.systemData?.address_map?.value.replace('width="600"', 'width="100%"').replace('height="450"', 'height="550"');
		});

		const InvalidMsg = (obj, txt) => {
			let th = obj !== undefined ? obj.target : undefined;
			if (th.value === '' && (th.type === 'text' || th.type === 'email' || th.type === 'textarea')) {
				th.setCustomValidity(txt);
			} else if (th.checked === false && (th.type === 'checkbox' || th.type === 'radio')) {
				th.setCustomValidity(txt);
			} else if (th.validity.typeMismatch) {
			// } else if (th.validity.valueMissing) {
				th.setCustomValidity(txt);
			} else {
				th.setCustomValidity('');
			}
			return true;
		};

		return {
			G,
			TR,
			InvalidMsg,
			map_frame,
		};
	}
}
</script>


<style lang="scss" scoped>
// .contacts-page{
// 	letter-spacing: 2px;
// }
.contacts-page a{
	text-decoration: none;
	color: #000000;
}

@media (max-width: 575.98px) {
	// padding-bottom: 800px;
	.maps iframe{
		width: 100% !important;
		height: 450px !important;
	}
}

@media (min-width: 576px) {
	// padding-bottom: 800px;
	.maps iframe{
		width: 100%;
		height: 450px;
	}
}

@media (min-width: 768px) {
	// padding-bottom: 350px;
	.maps iframe{
		width: 100%;
		height: 850px;
	}
}

@media (min-width: 992px) {
	// padding-bottom: 200px;
	.maps iframe{
		height: 700px;
	}
}
</style>
